module.exports = __webpack_public_path__ + "img/aboutUs_img14.10b89717.svg";